export default "__VITE_ASSET__xd$QPY5O__"